import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MicrosoftDefenderService } from '../../service';

export type SecurityAlertNotificationsConfig = typeof SecurityAlertNotificationsConfig._.Config;

export const SecurityAlertNotificationsConfig = IntegrationConfig.make({
  service: MicrosoftDefenderService,
  name: Integration_Handler_Names_Enum.SecurityAlertNotifications,
  configSchema: z.object({}),
});
